<template src="./paladin-filterset.html"></template>

<script>
import { ChiRhosNext, ChiRhosV3 } from '@paladin/core'

import Multiselect from 'vue-multiselect'
import PaladinPersonLookup from '../personlookup/paladin-person-lookup'
import * as PropertyOptions from '../../exports/propertyOptions'

const ChiRhosV3Api = new ChiRhosV3().api();

const ChiRhosNextApi = new ChiRhosNext().api()

export default {
  name: 'PaladinFilterSet',
  components: { Multiselect, PaladinPersonLookup, },
  props: {
    preset: {
      type: Object,
      default: null,
    },
    entityType:{
      type: String,
      required: true,
    },
    groupTypes: {
      type: Array,
      default: null,
    },
    showRemoveButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      operatorOptions: [
        {
          text: 'Within',
          value: 'within',
          filterName: 'within',
          filter: () => {
            return {
              property: null,
              not: false,
              value: null,
            }
          },
          canFilter: ['array'],
        },
        {
          text: 'Not Within',
          value: 'not-within',
          filterName: 'within',
          filter: () => {
            return {
              property: null,
              not: true,
              value: null,
            }
          },
          canFilter: ['array'],
        },
        {
          text: 'Contains',
          value: 'contains',
          filterName: 'contains',
          filter: () => {
            return {
              property: null,
              not: false,
              value: null,
            }
          },
          canFilter: ['string', 'dictionary~object', 'protected-properties'],
        },
        {
          text: 'Does Not Contain',
          value: 'not-contains',
          filterName: 'contains',
          filter: () => {
            return {
              property: null,
              not: true,
              value: null,
            }
          },
          canFilter: ['string', 'dictionary~object', 'protected-properties'],
        },
        {
          text: 'Contains (Case Insensitive)',
          value: 'contains-case-insensitive',
          filterName: 'containsCaseInsensitive',
          filter: () => {
            return {
              property: null,
              not: false,
              value: null,
            }
          },
          canFilter: ['string', 'dictionary~object', 'protected-properties'],
        },
        {
          text: 'Does Not Contain (Case Insensitive)',
          value: 'not-contains-case-insensitive',
          filterName: 'containsCaseInsensitive',
          filter: () => {
            return {
              property: null,
              not: true,
              value: null,
            }
          },
          canFilter: ['string', 'dictionary~object', 'protected-properties'],
        },
        {
          text: 'Greater Than',
          value: 'greater-than',
          filterName: 'greaterThan',
          filter: () => {
            return {
              property: null,
              not: false,
              value: null,
            }
          },
          canFilter: ['number', 'date', 'dictionary~number', 'dictionary~object', 'protected-properties', ],
        },
        {
          text: 'Greater Than Or Equal',
          value: 'greater-than-or-equal',
          filterName: 'greaterThanOrEqual',
          filter: () => {
            return {
              property: null,
              not: false,
              value: null,
            }
          },
          canFilter: ['number', 'date', 'dictionary~number', 'dictionary~object', 'protected-properties', ],
        },
        {
          text: 'Equal',
          value: 'equal',
          filterName: 'equal',
          filter: () => {
            return {
              property: null,
              not: false,
              value: null,
            }
          },
          canFilter: ['string', 'number', 'date', 'generic', 'dictionary~number', 'dictionary~object', 'protected-properties', ],
        },
        {
          text: 'Not Equal',
          value: 'not-equal',
          filterName: 'equal',
          filter: () => {
            return {
              property: null,
              not: true,
              value: null,
            }
          },
          canFilter: ['string', 'number', 'date', 'generic', 'dictionary~number', 'dictionary~object', 'protected-properties', ],
        },
        {
          text: 'Equal (Case Insensitive)',
          value: 'equal-case-insensitive',
          filterName: 'equalCaseInsensitive',
          filter: () => {
            return {
              property: null,
              not: false,
              value: null,
            }
          },
          canFilter: ['string', 'dictionary~', 'protected-properties'],
        },
        {
          text: 'Not Equal (Case Insensitive)',
          value: 'not-equal-case-insensitive',
          filterName: 'equalCaseInsensitive',
          filter: () => {
            return {
              property: null,
              not: true,
              value: null,
            }
          },
          canFilter: ['string', 'dictionary~object', 'protected-properties'],
        },
        {
          text: 'Less Than',
          value: 'less-than',
          filterName: 'lessThan',
          filter: () => {
            return {
              property: null,
              not: false,
              value: null,
            }
          },
          canFilter: ['number', 'date', 'dictionary~number', 'dictionary~object', 'protected-properties', ],
        },
        {
          text: 'Less Than Or Equal',
          value: 'less-than-or-equal',
          filterName: 'lessThanOrEqual',
          filter: () => {
            return {
              property: null,
              not: false,
              value: null,
            }
          },
          canFilter: ['number', 'date', 'dictionary~number', 'dictionary~object', 'protected-properties', ],
        },
        {
          text: 'Anniversary Date',
          value: 'anniversary-date',
          filterName: 'anniversary',
          filter: () => {
            return {
              property: null,
              not: false,
              value: null,
            }
          },
          canFilter: ['date', ],
        },
      ],
      presetting: false,
      filters: [],
      filterProperty: null,
      filterPropertyItem: null,
      filterOperator: null,
      filterValue: null,
      filterHasValue: true,
      filterValueDescriptionCache: null,
      filterGroupType: null,
      eventTypesByGroupType: [],
      availableEventTypes: [],
      availableProtectedProperties: [],
      filterDictionaryType: 'string',
    }
  },
  computed: {
    anniversaryOptionPart1: {
      get()
      {
        if(!this.filterValue) return null

        var split = this.filterValue.split(':')

        if(split.length !== 2) return null

        if(split[1] === 'this' || split[1] === 'next') return this.filterValue

        return split[0] + ':' + '1'
      },
      set(val)
      {
        this.filterValue = val
      }
    },
    anniversaryOptionPart2: {
      get()
      {
        if(!this.filterValue) return null

        var split = this.filterValue.split(':')

        if(split.length !== 2 || split[0] === 'this' || split[0] === 'next') return null

        return split[1]
      },
      set(val)
      {
        this.filterValue = this.anniversaryOptionPart1.split(':')[0] + ':' + val
      }
    },
    propertyOptions: function() {
      return PropertyOptions.propertyOptions
    },
    filterValueDescription: function (){
      if(this.filterValueDescriptionCache != null)
      {
        return this.filterValueDescriptionCache
      }
      return this.filterValue
    },
    protectedProperties: function() {
      return this.availableProtectedProperties.map((item) => {
        return {
          value: item.property.entityId,
          text: item.property.name,
        }
      })
    },
    groupTypeOptions: function() {
      return this.groupTypes.map((item) => {
        return {
          value: item.entity.entityId,
          text: item.entity.name,
        }
      })
    },
    computedOperatorOptions: function() {
      if (this.selectedFilterProperty) {

        let controlType = this.selectedFilterProperty.controlType

        if (controlType === 'dictionary~object' || controlType === 'protected-properties')
        {
          controlType = this.filterDictionaryType
        }
        
        if(!['string', 'number', 'date', 'array', 'dictionary~number', ].includes(controlType))
        {
          controlType = 'generic'
        }

        return this.operatorOptions.filter((i) => {
          return i.canFilter.includes(controlType)
        })
      } else {
        return [] // should never happen!
      }
    },
    selectedFilterProperty() {
      return this.propertyOptions[this.entityType].find((op) => {
        return op.value === this.filterProperty
      })
    },
    selectedFilterOperator() {
      return this.operatorOptions.find((op) => {
        return op.value === this.filterOperator
      })
    },
  },
  watch: {
    preset: function(val)
    {
      this.init()
    },
    filterProperty: function(val)
    {
      this.filterOperator = null
      this.filterValue = null
      this.filterHasValue = true
      this.filterValueDescriptionCache = null
      this.filterDictionaryType = 'string'
    },
    filters: function(val)
    {
      if(this.presetting) return // we don't do this on a preset

      let _filterSet = {
            within: [],
            contains: [],
            containsCaseInsensitive: [],
            greaterThan: [],
            greaterThanOrEqual: [],
            equal: [],
            equalCaseInsensitive: [],
            lessThanOrEqual: [],
            lessThan: [],
            anniversary: [],
          }

      this.filters.forEach(function(filter) {
        switch(filter.comparatorName)
        {
          case 'within':
            _filterSet.within.push(filter.filter)
            break;
          case 'contains':
            _filterSet.contains.push(filter.filter)
            break;
          case 'containsCaseInsensitive':
            _filterSet.containsCaseInsensitive.push(filter.filter)
            break;
          case 'greaterThan':
            _filterSet.greaterThan.push(filter.filter)
            break;
          case 'greaterThanOrEqual':
            _filterSet.greaterThanOrEqual.push(filter.filter)
            break;
          case 'equal':
            _filterSet.equal.push(filter.filter)
            break;
          case 'equalCaseInsensitive':
            _filterSet.equalCaseInsensitive.push(filter.filter)
            break;
          case 'lessThanOrEqual':
            _filterSet.lessThanOrEqual.push(filter.filter)
            break;
          case 'lessThan':
            _filterSet.lessThan.push(filter.filter)
            break;
          case 'anniversary':
            _filterSet.anniversary.push(filter.filter)
            break;
        }
      })

      this.$emit('update', _filterSet)
    },
  },
  created: function() {
  },
  mounted() {
    this.$nextTick(function() {
      this.init()
    })
  },
  methods: {
    init() {

        this.filters = []
        this.filterProperty = null
        this.filterPropertyItem = null
        this.filterOperator = null
        this.filterValue = null
        this.filterHasValue = true
        this.filterDictionaryType = 'string'
        this.filterValueDescriptionCache = null
        this.filterGroupType = null

        ChiRhosV3Api.PersonApi.apiPersonProtectedPropertiesAvailablePost({ apiRequest: { } }).then(
          response => {
            if(response.data)
            {
              this.availableProtectedProperties = response.data

              if(this.preset)
              {
                this.presetting = true

                this.createFilters(this.preset.within, 'within')
                this.createFilters(this.preset.contains, 'contains')
                this.createFilters(this.preset.containsCaseInsensitive, 'containsCaseInsensitive')
                this.createFilters(this.preset.greaterThan, 'greaterThan')
                this.createFilters(this.preset.greaterThanOrEqual, 'greaterThanOrEqual')
                this.createFilters(this.preset.equal, 'equal')
                this.createFilters(this.preset.equalCaseInsensitive, 'equalCaseInsensitive')
                this.createFilters(this.preset.lessThanOrEqual, 'lessThanOrEqual')
                this.createFilters(this.preset.lessThan, 'lessThan')
                this.createFilters(this.preset.anniversary, 'anniversary')

                this.presetting = false
              }
            }
          },
          error => {
            console.error(error)
            error.json().then(body => {
              this.$toast(body.Message, "error")
            })
          }
        )
    },
    populateEventTypes(groupType)
    {
      if(!this.eventTypesByGroupType[groupType])
      {
        this.eventTypesByGroupType[groupType] = [] // start with init so this isn't done multiple times

        ChiRhosNextApi.EventTypeApi.listForGroupType({ entityId: this.filterGroupType }).then(
            (response) => {
              this.eventTypesByGroupType[groupType] = response.data.map((item) => {
              return {
                value: item.entity.entityId,
                text: item.entity.name,
              }})
              this.availableEventTypes = this.eventTypesByGroupType[groupType]
            },
            (error) => {
              console.error(error)
              this.$toast(error, 'error')
            })
      }
      else
      {
        this.availableEventTypes = this.eventTypesByGroupType[groupType]
      }
    },
    createFilters(source, type)
    {
      if(source)
      {
        let _filters = this.filters
        let _generateUUID = this.generateUUID
        let _operator = this.operatorOptions.find((op) => {
          return op.filterName === type
        })

        if(_operator)
        {

        // TODO?: set the valueDescription if something like a person or event so it's not just a GUID
          source.forEach(function (value){
            _filters.push({ id: _generateUUID(), comparatorName: type, operatorText: _operator.text ,filter: value, valueDescription: value.value })
          })
        }
      }
    },
    upperCaseFirst(text)
    {
      return text.toString().charAt(0).toUpperCase() + text.slice(1)
    },
     generateUUID() { // Public Domain/MIT https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
    var d = new Date().getTime()// Timestamp
    var d2 = (performance && performance.now && (performance.now()*1000)) || 0// Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16// random number between 0 and 16
        if(d > 0){// Use timestamp until depleted
            r = (d + r)%16 | 0
            d = Math.floor(d/16)
        } else {// Use microseconds since page-load if supported
            r = (d2 + r)%16 | 0
            d2 = Math.floor(d2/16)
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    });
    },
    addFilter(evt) {
      evt.preventDefault()

      if(this.selectedFilterProperty)
      {
        if(this.selectedFilterOperator)
        {
          let _filter = { id: this.generateUUID(), comparatorName:this.selectedFilterOperator.filterName, filter: this.selectedFilterOperator.filter() }
          _filter.filter.property = this.selectedFilterProperty.value

          if (this.selectedFilterProperty.controlType === 'dictionary~number' && !this.filterPropertyItem)
          {
            this.$toast('You must enter an item key for number dictionaries', 'error')
            return
          }

          if ((this.selectedFilterProperty.controlType === 'dictionary~object' || this.selectedFilterProperty.controlType === 'protected-properties') && !this.filterPropertyItem)
          {
            this.$toast('You must enter an item key for dictionaries', 'error')
            return
          }

if(this.filterPropertyItem) _filter.filter.property += ":" + this.filterPropertyItem

           if (this.selectedFilterProperty.controlType === 'number' || this.selectedFilterProperty.controlType === 'dictionary~number' || (this.selectedFilterProperty.controlType === 'dictionary~object' && this.filterDictionaryType == 'number')) {
              _filter.filter.value = this.filterValue * 1
            } else if (this.selectedFilterProperty.controlType === 'boolean' || (this.selectedFilterProperty.controlType === 'dictionary~object' && this.filterDictionaryType == 'boolean') || (this.selectedFilterProperty.controlType === 'protected-properties' && this.filterDictionaryType == 'boolean')) {
              _filter.filter.value = this.filterValue == true || this.filterValue == 'true'
              this.filterValueDescriptionCache = _filter.filter.value.toString()
           }
          //  else if (this.selectedFilterProperty.controlType === 'date' || this.filterDictionaryType == 'date')
          //  {
                // todo?
          //  }
            else {
              _filter.filter.value = this.filterValue
            }
            _filter.valueDescription = this.filterValueDescription
            _filter.operatorText = this.selectedFilterOperator.text

            console.log(_filter)

            this.filters.push(_filter)

            this.filterProperty = null
            this.filterPropertyItem = null
            this.filterOperator = null
            this.filterValue = null
            this.filterHasValue = true
            this.filterValueDescriptionCache = null
            this.filterDictionaryType = 'string'
        }
        else
        {
          this.$toast('You must select a type of property filter', 'error')
        }
      }
      else
      {
        this.$toast('You must select a property', 'error')
      }
    },
    resolvePropertyText(text)
    {
      var prop = text.indexOf(':') >= 0 ? text.split(':')[0] : text

      var item = this.propertyOptions[this.entityType].find((op) => {
        return op.value === prop
      })

      if(item)
      {
        // we have a property option!

        var ret = item.text

        if(text.indexOf(':') >= 0)
        {
          var key = '- unknown -'

          // need to add the dict part if we can!

          var val = text.split(':')[1]

          if(val)
          {
            if(item.controlType === 'protected-properties')
            {
              var protectedProp = this.availableProtectedProperties.find((op) => {
                return String(op.property.entityId) === val
              })

              if(protectedProp) key = protectedProp.property.name
            }
          }

          ret += ' (' + key + ')'
        }

        return ret
      }

      return text
    },
    personSelected(value) {
      this.filterValue = value.entityId
      this.filterValueDescriptionCache = value.firstName + ' ' + value.lastName
    },
    setEventTypeName(val)
    {
      if(this.filterGroupType && this.eventTypesByGroupType[this.filterGroupType])
      {
        var item = this.eventTypesByGroupType[this.filterGroupType].find((op) => {
          return op.value === val
        })

        if(item)
        {
          this.filterValueDescriptionCache = item.text
        }
      }
    },
    removeFilter(filter)
    {
      var item = this.filters.find((op) => {
        return op.id === filter.id
      })

      if(item)
      {
        this.filters.splice(this.filters.indexOf(item), 1)

        return
      }

      this.$toast('Cannot find filter to remove', 'error')
    },
    remove()
    {
      this.$emit('remove')
    },
    hasValueChange(ev)
    {
      if(ev.target.value == "true")
      {
        this.filterValue = null
      }
    },
  },
}
</script>

<style lang="scss"></style>
